import { Check } from 'lucide-react'

import { cn } from 'src/shared/utils/cn'

interface ULCheckBoxProps {
  checked: boolean
  onClick?: () => void
}

export default function ULCheckBox({ checked, onClick }: ULCheckBoxProps) {
  return (
    <div
      onClick={onClick}
      className={cn(
        'flex size-[25px] shrink-0 cursor-pointer items-center justify-center rounded-full border border-border/100 bg-white text-border/100',
        checked && 'border-transparent bg-primary text-white',
      )}
    >
      <Check size={12} strokeWidth={3} />
    </div>
  )
}
